import { useQuery } from '@apollo/react-hooks';
import { useCountry } from '../../components/CountrySelector';
import { GET_ORDER_QUERY, GetOrderQuery, GetOrderQueryVariables } from './order.rest';

export const useOrder = (orderNumber: string) => {
  const { country } = useCountry();
  const { data, loading, error } = useQuery<GetOrderQuery, GetOrderQueryVariables>(
    GET_ORDER_QUERY,
    { variables: { countryCode: country.alpha2Code, orderNumber } }
  );

  return { order: data?.getOrder.data[0], orderItems: data?.getOrder.included, loading, error };
};
